/* WeHatke Gift Finder. Rules-based; product list in gift-finder-data.json, live price/stock from /products/<handle>.js */
(function () {
  var root = document.querySelector('[data-gf]');
  if (!root) return;
  var stepEl = root.querySelector('[data-gf-step]');
  var pillsEl = root.querySelector('[data-gf-pills]');
  var pickedEl = root.querySelector('[data-gf-picked]');
  var ICON = root.getAttribute('data-icons') || '';
  var D = null;
  var S = { lang: 'en', r: null, o: null, f: null, d: null, b: null, step: 0, shown: 0, list: [], started: false, presetB: false };
  var STEPS = ['r', 'o', 'f', 'd', 'b'];
  try { S.lang = sessionStorage.getItem('gf_lang') || 'en'; } catch (e) {}

  var T = {
    en: { q_r: 'Who is the gift for?', q_o: 'What is the occasion?', q_f: 'What should the gift say?',
          q_d: 'What can you add to make it theirs?', q_b: 'How much do you want to spend?', hint: 'Tap one to continue',
          p_r: 'Who', p_o: 'Occasion', p_f: 'Feeling', p_d: 'Detail', p_b: 'Budget',
          back: 'Back', restart: 'Start again', any_d: 'Not sure yet', any_b: 'Any budget', surprise: 'Not sure, surprise me',
          results: 'Gifts that fit', more: 'Show more gifts', view: 'View and personalise', from: 'From',
          none: 'No gifts matched. Try a different budget or start again.', loading: 'Loading…', change: 'Tap to change' },
    hi: { q_r: 'गिफ्ट किसके लिए है?', q_o: 'मौका क्या है?', q_f: 'गिफ्ट से क्या कहना चाहते हैं?',
          q_d: 'गिफ्ट को उनका बनाने के लिए क्या जोड़ेंगे?', q_b: 'आप कितना खर्च करना चाहते हैं?', hint: 'आगे बढ़ने के लिए किसी एक पर टैप करें',
          p_r: 'किसके लिए', p_o: 'मौका', p_f: 'भावना', p_d: 'डिटेल', p_b: 'बजट',
          back: 'पीछे', restart: 'फिर से शुरू करें', any_d: 'अभी तय नहीं', any_b: 'कोई भी बजट', surprise: 'पता नहीं, आप ही सुझाइए',
          results: 'आपके लिए सही गिफ्ट', more: 'और गिफ्ट दिखाएँ', view: 'देखें और पर्सनलाइज़ करें', from: '',
          none: 'कोई गिफ्ट नहीं मिला। बजट बदलकर देखें या फिर से शुरू करें।', loading: 'लोड हो रहा है…', change: 'बदलने के लिए टैप करें' }
  };
  // option key -> icon file key
  var IC = { r: { work: 'work-person' },
             o: { karwa: 'karwa-chauth', work: 'corporate', justbecause: 'any', remember: 'remember' },
             f: {}, d: {}, b: { u300: 'budget-low', '300': 'budget-mid', '600': 'budget-mid', '1000': 'budget-high', '1500': 'budget-high' } };
  function t(k) { return (T[S.lang] || T.en)[k]; }
  function L(row) { return S.lang === 'hi' ? row[2] : row[1]; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function icon(step, k) { return ICON + 'gf-ic-' + ((IC[step] && IC[step][k]) || k) + '.webp?v=' + (D && D.v || 1); }
  function track(name, data) {
    var payload = Object.assign({ lang: S.lang }, data || {});
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload); } catch (e) {}
    try { root.dispatchEvent(new CustomEvent('gf:event', { detail: { name: name, data: payload }, bubbles: true })); } catch (e) {}
  }
  function key(list, k) { for (var i = 0; i < list.length; i++) if (list[i][0] === k) return i; return -1; }
  function price(n) { var v = '₹' + Math.round(n).toLocaleString('en-IN'); return S.lang === 'hi' ? v + ' से शुरू' : t('from') + ' ' + v; }

  // product row: [handle, title, img, price, rec[], occ[], feel[], det[], band]
  var JB, SURPRISE;
  function recIndex() { return D.rec_idx[S.r]; }
  function base() {
    var ri = recIndex();
    return D.p.filter(function (p) {
      if (p[4].indexOf(ri) < 0) return false;
      if (S.o !== null && S.o !== JB && p[5].indexOf(S.o) < 0) return false;
      return true;
    });
  }
  function withFeel(list) { return (S.f === null || S.f === SURPRISE) ? list : list.filter(function (p) { return p[6].indexOf(S.f) >= 0; }); }
  function withDet(list) { return S.d === null || S.d === -1 ? list : list.filter(function (p) { return p[7].indexOf(S.d) >= 0; }); }
  function bandOk(p) { if (S.b === null || S.b === -1) return true; if (S.b === 'plus') return p[8] >= 3; return p[8] === S.b; }

  function tile(val, label, src, extra) {
    return '<button type="button" class="gf-tile' + (extra ? ' ' + extra : '') + '" data-v="' + val + '">' +
      '<img class="gf-ic" src="' + esc(src) + '" alt="" width="72" height="72" decoding="async"' + (S.step === 0 ? '' : ' loading="lazy"') + '>' +
      '<span class="gf-tile-label">' + esc(label) + '</span></button>';
  }

  function options() {
    var html = '', s = STEPS[S.step];
    if (s === 'r') {
      D.rec.forEach(function (r, i) { html += tile(i, L(r), icon('r', r[0])); });
    } else if (s === 'o') {
      D.branch[String(recIndex())].forEach(function (oi) { html += tile(oi, L(D.occ[oi]), icon('o', D.occ[oi][0])); });
    } else if (s === 'f') {
      var b = base(), cnt = {};
      b.forEach(function (p) { p[6].forEach(function (f) { cnt[f] = (cnt[f] || 0) + 1; }); });
      Object.keys(cnt).map(Number).filter(function (f) { return f !== SURPRISE; })
        .sort(function (a, c) { return cnt[c] - cnt[a]; }).slice(0, 5)
        .forEach(function (f) { html += tile(f, L(D.feel[f]), icon('f', D.feel[f][0])); });
      html += tile(SURPRISE, t('surprise'), icon('f', 'surprise'), 'gf-tile--soft');
    } else if (s === 'd') {
      var bf = withFeel(base()), dc = {};
      bf.forEach(function (p) { p[7].forEach(function (d) { dc[d] = (dc[d] || 0) + 1; }); });
      Object.keys(dc).map(Number).sort(function (a, c) { return dc[c] - dc[a]; })
        .forEach(function (d) { html += tile(d, L(D.det[d]), icon('d', D.det[d][0])); });
      html += tile(-1, t('any_d'), icon('d', 'any'), 'gf-tile--soft');
    } else if (s === 'b') {
      var bd = withDet(withFeel(base())), bc = {};
      bd.forEach(function (p) { bc[p[8]] = 1; });
      D.band.forEach(function (row, i) { if (bc[i]) html += tile(i, L(row), icon('b', row[0])); });
      html += tile(-1, t('any_b'), icon('b', 'any'), 'gf-tile--soft');
    }
    return html;
  }

  function pills() {
    pillsEl.innerHTML = STEPS.map(function (s, i) {
      var st = i < S.step ? 'done' : i === S.step ? 'now' : '';
      return '<li class="gf-pill ' + st + '"><span class="gf-pill-n">' + (i < S.step ? '✓' : i + 1) + '</span><span class="gf-pill-t">' + t('p_' + s) + '</span></li>';
    }).join('');
    var chips = '';
    STEPS.forEach(function (s, i) {
      if (i >= S.step || S[s] === null) return;
      var txt = s === 'r' ? L(D.rec[S.r]) : s === 'o' ? L(D.occ[S.o]) : s === 'f' ? (S.f === SURPRISE ? t('surprise') : L(D.feel[S.f]))
        : s === 'd' ? (S.d === -1 ? t('any_d') : L(D.det[S.d])) : (S.b === -1 ? t('any_b') : S.b === 'plus' ? '₹1,000+' : L(D.band[S.b]));
      chips += '<button type="button" class="gf-picked-chip" data-goto="' + i + '" title="' + esc(t('change')) + '">' + esc(txt) + ' <span aria-hidden="true">✎</span></button>';
    });
    pickedEl.innerHTML = chips;
    pickedEl.querySelectorAll('[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () { goto(Number(b.getAttribute('data-goto'))); });
    });
  }
  function goto(i) {
    for (var k = i; k < STEPS.length; k++) if (!(STEPS[k] === 'b' && S.presetB)) S[STEPS[k]] = null;
    S.step = i; track('gf_edit', { step: i + 1 }); render(); scrollTop();
  }

  function render() {
    pills();
    if (S.step >= 2 && !D.p) { stepEl.innerHTML = '<p class="gf-hint gf-wait">' + t('loading') + '</p>'; return; }
    if (S.step >= STEPS.length) return results();
    stepEl.innerHTML = '<h2 class="gf-q">' + esc(t('q_' + STEPS[S.step])) + '</h2><p class="gf-hint">' + esc(t('hint')) + '</p>' +
      '<div class="gf-grid gf-grid--' + STEPS[S.step] + '">' + options() + '</div>' + nav();
    bindTiles();
    bindNav();
  }
  function bindTiles() {
    stepEl.querySelectorAll('[data-v]').forEach(function (b) {
      b.addEventListener('click', function () { answer(b.getAttribute('data-v')); });
    });
  }
  function nav() {
    return S.step > 0 ? '<div class="gf-nav"><button type="button" class="gf-link" data-gf-back>← ' + t('back') + '</button>' +
      '<button type="button" class="gf-link" data-gf-restart>' + t('restart') + '</button></div>' : '';
  }
  function bindNav() {
    var bk = stepEl.querySelector('[data-gf-back]'), rs = stepEl.querySelector('[data-gf-restart]');
    if (bk) bk.addEventListener('click', back);
    if (rs) rs.addEventListener('click', function () { track('gf_restart', { step: S.step + 1 }); reset(); render(); scrollTop(); });
  }
  function reset() { S.r = S.o = S.f = S.d = null; if (!S.presetB) S.b = null; S.step = 0; }
  function back() {
    S.step = Math.max(0, S.step - 1);
    if (STEPS[S.step] === 'b' && S.presetB) S.step--;
    S[STEPS[S.step]] = null; render(); scrollTop();
  }
  function answer(raw) {
    var s = STEPS[S.step], v = Number(raw);
    if (!S.started) { S.started = true; track('gf_start', {}); }
    S[s] = v;
    track('gf_step', { step: S.step + 1, step_name: s, answer: label(s) });
    S.step++;
    if (STEPS[S.step] === 'b' && S.presetB) S.step++;
    render(); scrollTop();
  }
  function label(s) {
    var v = S[s];
    if (v === null || v === -1) return 'any';
    if (s === 'r') return D.rec[v][0];
    if (s === 'o') return D.occ[v][0];
    if (s === 'f') return D.feel[v][0];
    if (s === 'd') return D.det[v][0];
    if (s === 'b') return v === 'plus' ? '1000plus' : D.band[v][0];
  }
  function scrollTop() {
    var y = root.querySelector('.gf-quiz').getBoundingClientRect().top + window.pageYOffset - 70;
    if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function score(p) {
    var sc = 0;
    if (S.f !== null && S.f !== SURPRISE && p[6].indexOf(S.f) >= 0) sc += 10;
    if (S.d !== null && S.d !== -1 && p[7].indexOf(S.d) >= 0) sc += 30;
    if (S.o !== null && S.o !== JB && p[5].indexOf(S.o) >= 0) sc += 25;
    return sc;
  }
  function results() {
    var b = base(), exact = withDet(withFeel(b)).filter(bandOk), seen = {}, list = [];
    // exact matches first, then the nearest gifts (relax detail, then feeling, then budget)
    [exact, withFeel(b).filter(bandOk), b.filter(bandOk), b].forEach(function (grp, gi) {
      grp.slice().sort(function (a, c) { return score(c) - score(a); }).forEach(function (p) {
        if (!seen[p[0]] && (gi === 0 || list.length < 8 || exact.length === 0)) { seen[p[0]] = 1; list.push(p); }
      });
    });
    S.list = list; S.shown = 0;
    track('gf_complete', { recipient: label('r'), occasion: label('o'), feeling: label('f'), detail: label('d'),
      budget: label('b'), results: list.length, exact_results: exact.length });
    if (!list.length) track('gf_no_results', {});
    stepEl.innerHTML = '<h2 class="gf-q">' + t('results') + '</h2>' +
      (list.length ? '<div class="gf-results" data-gf-results></div><div class="gf-more-wrap"></div>' : '<p class="gf-hint">' + t('none') + '</p>') +
      '<div class="gf-nav"><button type="button" class="gf-link" data-gf-back>← ' + t('back') + '</button>' +
      '<button type="button" class="gf-link" data-gf-restart>' + t('restart') + '</button></div>';
    bindNav();
    more();
  }
  function more() {
    var box = stepEl.querySelector('[data-gf-results]'), wrap = stepEl.querySelector('.gf-more-wrap');
    if (!box) return;
    var batch = S.list.slice(S.shown, S.shown + 8), start = S.shown;
    S.shown += batch.length;
    batch.forEach(function (p, i) {
      var pos = start + i + 1, a = document.createElement('a');
      a.className = 'gf-card'; a.href = '/products/' + p[0];
      a.innerHTML = '<span class="gf-card-img"><img src="' + esc(p[2]) + '" alt="' + esc(p[1]) + '" loading="lazy" width="400" height="400"></span>' +
        '<span class="gf-card-title">' + esc(p[1]) + '</span><span class="gf-card-price" data-price>' + price(p[3]) + '</span>' +
        '<span class="gf-card-cta">' + t('view') + '</span>';
      a.addEventListener('click', function () {
        try { sessionStorage.setItem('gf_src', JSON.stringify({ h: p[0], r: label('r'), o: label('o') })); } catch (e) {}
        track('gf_result_click', { product_handle: p[0], product_name: p[1], position: pos, recipient: label('r'), occasion: label('o') });
      });
      box.appendChild(a);
      live(p, a);
    });
    wrap.innerHTML = S.shown < S.list.length ? '<button type="button" class="gf-more">' + t('more') + '</button>' : '';
    var m = wrap.querySelector('.gf-more'); if (m) m.addEventListener('click', more);
  }
  function live(p, el) {
    fetch('/products/' + p[0] + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.available) { el.remove(); return; }
      el.querySelector('[data-price]').textContent = price(j.price_min / 100);
    }).catch(function () {});
  }

  function setLang(l, init) {
    S.lang = l; try { sessionStorage.setItem('gf_lang', l); } catch (e) {}
    root.querySelectorAll('[data-gf-lang]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-gf-lang') === l)); });
    root.querySelector('.gf-quiz').setAttribute('lang', l);
    if (!init && D && D.rec) render();
  }
  root.querySelectorAll('[data-gf-lang]').forEach(function (b) {
    b.addEventListener('click', function () { var l = b.getAttribute('data-gf-lang'); if (l !== S.lang) { track('gf_language_switch', { to: l }); setLang(l); } });
  });
  root.querySelectorAll('[data-gf-budget]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!D) return;
      var v = b.getAttribute('data-gf-budget');
      S.b = v === '1000plus' ? 'plus' : key(D.band, v); S.presetB = true;
      track('gf_budget_preset', { budget: v });
      reset(); render(); scrollTop();
    });
  });

  function presets() {
    var q = new URLSearchParams(location.search), ri, oi;
    if (q.get('b')) { var bv = q.get('b'); S.b = bv === '1000plus' ? 'plus' : key(D.band, bv); if (S.b !== -1) S.presetB = true; else S.b = null; }
    if (q.get('r') && (ri = key(D.rec, q.get('r'))) >= 0) {
      S.r = ri; S.step = 1;
      if (q.get('o') && (oi = key(D.occ, q.get('o'))) >= 0 && D.branch[String(D.rec_idx[ri])].indexOf(oi) >= 0) { S.o = oi; S.step = 2; }
      track('gf_preset', { recipient: label('r'), occasion: S.o !== null ? label('o') : 'none' });
    }
  }

  // quiz settings are inline (no request before the first tap); the product list loads in the background
  try { D = JSON.parse(document.getElementById('gf-config').textContent); } catch (e) { return; }
  D.p = null;
  JB = key(D.occ, 'justbecause'); SURPRISE = key(D.feel, 'surprise');
  fetch(root.getAttribute('data-src')).then(function (r) { return r.json(); }).then(function (j) {
    j.p.forEach(function (p) { p[2] = D.ip + p[2] + '?width=400'; });
    D.p = j.p;
    if (S.step >= 2) render();
  }).catch(function () { stepEl.innerHTML = '<p>' + t('none') + '</p>'; });
  setLang(S.lang, true);
  presets();
  // step 1 is already in the page HTML: just wire it up (no re-render, no second icon download)
  if (S.step === 0 && S.lang === 'en' && stepEl.querySelector('.gf-tile')) bindTiles(); else render();
})();
